import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ---------------addDepartmentSchema-------------
export const addLeaveManagementSchema = Yup.object()
  .shape({
    leaveType: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.field.name)),
    allowedDays: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.field.days)),
  })
  .required();
